// extracted by mini-css-extract-plugin
export default {"cls1":"dZ5kOa43lgRuLyB3FIpf","cls2":"DC648LdEbOs6rEDHJNAR dZ5kOa43lgRuLyB3FIpf","isTabletUp":"QQLKSoHlUJRNkEGSskg9"};